import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import styles from "./ErrorScreen.module.css";

import { IconV2 } from "@/components/atoms/IconV2";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";
import { spacing } from "@/styles/tokens";

interface Props {
  title?: string;
  description?: string;
  action?: ReactNode;
  correlationId?: string;
}

export const ErrorScreen = ({
  title,
  description,
  action,
  correlationId,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <IconV2 name="circleAlert" size="l" />
      </div>
      <Stack align="center" gap={spacing.sm}>
        <Text variant="h2" as="h4" className={styles.text}>
          {title ?? t("plants.unexpectedError")}
        </Text>
        <Text variant="body1" color="default" as="p" className={styles.text}>
          {description ?? t("plants.unexpectedErrorDescription")}
        </Text>
        {correlationId && (
          <Text variant="caption" color="default" className={styles.ref}>
            Ref: {correlationId}
          </Text>
        )}
        {action}
      </Stack>
    </div>
  );
};
